module.exports = __webpack_public_path__ + "img/bril.25f3eaff.png";